import { NgModule, Component }          from '@angular/core';
import { BrowserModule }                from '@angular/platform-browser';
import { HttpModule, BrowserXhr }       from '@angular/http';
import { LocationStrategy,
         HashLocationStrategy }         from '@angular/common';

import { AppComponent }                 from './app.component';
import { FormsModule, 
         NgModel, ReactiveFormsModule }                      from '@angular/forms';
import { BsDropdownModule }               from 'ngx-bootstrap/dropdown';
import { NAV_DROPDOWN_DIRECTIVES }      from './shared/nav-dropdown.directive';
import { platformBrowserDynamic }       from "@angular/platform-browser-dynamic";

import { ChartsModule }                 from 'ng2-charts/ng2-charts';
import { SIDEBAR_TOGGLE_DIRECTIVES }    from './shared/sidebar.directive';
import { AsideToggleDirective }         from './shared/aside.directive';
import { BreadcrumbsComponent }         from './shared/breadcrumb.component';
import { SmartResizeDirective }         from './shared/smart-resize.directive';
import { AlertModule, ProgressbarModule }              from 'ngx-bootstrap';
import { PopoverModule } from 'ng2-popover';


import { APIService }                   from './_services/api.service';
import { ToastService }                 from './_services/toast.service';
import { UserService }                  from './_services/user.service';
import { StorageService }               from './_services/storage.service';
import { SpinnerModule }                from './_services/spinner.module';
import { RolesService }                 from './_services/roles.service';
import { CustomBrowserXhr }                 from './_services/custom.xhr';

import { LoggedInGuard }                from './_guards/logged-in.guard';
import {Ng2PaginationModule}            from 'ng2-pagination';
import { Uploader }                     from 'angular2-http-file-upload';

// Routing Module
import { AppRoutingModule }             from './app.routing';

import {ToasterModule, ToasterService}  from 'angular2-toaster';
import { BsDatepickerModule } from 'ngx-bootstrap';

//Layouts
import { FullLayoutComponent }          from './layouts/full-layout.component';
import { SimpleLayoutComponent }        from './layouts/simple-layout.component';

import {MainPipe}                      from './pipes/main-pipe.module';
import {DndModule} from 'ng2-dnd';
import { AngularMultiSelectModule } from 'angular2-multiselect-dropdown/angular2-multiselect-dropdown';
import { OrderModule } from 'ngx-order-pipe';
import {NgAutoCompleteModule} from "ng-auto-complete";


@NgModule({
    imports: [
        BrowserModule,
        AppRoutingModule,
        HttpModule,
        FormsModule,
        ReactiveFormsModule,
        BsDropdownModule.forRoot(),
        ChartsModule,
        AlertModule.forRoot(),
        ProgressbarModule.forRoot(),
        ToasterModule,
        SpinnerModule,
        Ng2PaginationModule,
        BsDatepickerModule.forRoot(),
        PopoverModule,
        MainPipe,
        DndModule.forRoot(),
        OrderModule,
        AngularMultiSelectModule,
        NgAutoCompleteModule
    ],
    declarations: [
        AppComponent,
        FullLayoutComponent,
        NAV_DROPDOWN_DIRECTIVES,
        SimpleLayoutComponent,
        BreadcrumbsComponent,
        SIDEBAR_TOGGLE_DIRECTIVES,
        AsideToggleDirective,
        SmartResizeDirective
    ],
    providers: [{
        provide: LocationStrategy,
        useClass: HashLocationStrategy
    }, APIService, ToastService, UserService, LoggedInGuard, RolesService, Uploader, StorageService],
    bootstrap: [ AppComponent]
})

export class AppModule { }



// WEBPACK FOOTER //
// ./src/app/app.module.ts